var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18747 6.18746H5.31237V10.3124L5.31254 10.3125C5.31254 10.558 5.44357 10.785 5.65627 10.9078C5.86896 11.0307 6.13102 11.0307 6.34373 10.9078C6.55643 10.7851 6.68746 10.558 6.68746 10.3125V6.18746H10.8125C11.058 6.18746 11.285 6.05643 11.4078 5.84373C11.5307 5.63104 11.5307 5.36898 11.4078 5.15627C11.2851 4.94357 11.058 4.81254 10.8125 4.81254H6.68746V0.687464C6.68746 0.441969 6.55643 0.214965 6.34373 0.0921884C6.13104 -0.0307295 5.86898 -0.0307295 5.65627 0.0921884C5.44357 0.214934 5.31254 0.44196 5.31254 0.687464V4.81236L1.18746 4.81254C0.941969 4.81254 0.714965 4.94357 0.592188 5.15626C0.469271 5.36895 0.469271 5.63102 0.592188 5.84373C0.714934 6.05642 0.941964 6.18746 1.18747 6.18746Z",
    fill: "#4872F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.4676fa40d9b9056bdfafe7c9626c3c49.svg";
export { ForwardRef as ReactComponent };